// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fa898753","977":"da0172d4"}[chunkId] + ".chunk.js";
};